import { IReaderAccountFee } from 'src/types/DTO/readerAccountFee/IReaderAccountFee';

export const toReaderAccountFee = (fee: any): IReaderAccountFee => ({
  id: fee?.id,
  fee: fee?.fee,
  duration: fee?.effect,
  description: fee?.feeDes,
});

export const toReaderAccountFees = (data: any): IReaderAccountFee[] =>
  data?.map((item: any) => toReaderAccountFee(item));
